export default __webpack_public_path__ + "static/media/ilustración_disapproved_dsk.12f2b822.svg";